import { SearchInput } from 'components'
import React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { State } from 'store/types'

import * as actions from './actions'
import { getSearchInputValue, isTyping } from './selectors'

interface Props {
  showSelectedOnly?: boolean
}

interface OwnProps {
  isTyping: boolean
}

const SearchInputContainer = (props: Props) => (!props.showSelectedOnly ? <SearchInput {...props} /> : null)

const mapStateToProps = (state: State) => ({
  showSelectedOnly: state.search.showSelectedOnly,
  value: getSearchInputValue(state),
  isTyping: isTyping(state),
})

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps) => ({
  onDebounceEnd: () => {
    dispatch(actions.stopTyping())
    dispatch(actions.searchForStoresLogic())
  },
  onChange: (value: any[]) => {
    if (!ownProps.isTyping) {
      dispatch(actions.startTyping())
    }
    dispatch(actions.setSearchInputValue(value))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchInputContainer) as any
